import { Controller } from "stimulus";

const DEFAULT_SWATCH = '#FFA000';

export default class extends Controller {

  connect() {
    this.bindPicker('colorPickerButton1', 'colorCodeInput1');
    this.bindPicker('colorPickerButton2', 'colorCodeInput2');
  }

  bindPicker(pickerId, inputId) {
    const picker = document.getElementById(pickerId);
    const input = document.getElementById(inputId);
    if (!picker || !input) return;

    picker.value = this.normalizeHex(input.value) || DEFAULT_SWATCH;

    picker.addEventListener('input', () => {
      input.value = picker.value.toUpperCase();
    });

    input.addEventListener('input', () => {
      const hex = this.normalizeHex(input.value);
      if (hex) picker.value = hex;
    });
  }

  // <input type="color"> only accepts "#rrggbb"; accept the shorthand forms users type.
  normalizeHex(value) {
    const match = (value || '').trim().match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (!match) return null;

    let hex = match[1];
    if (hex.length === 3) hex = hex.replace(/./g, (c) => c + c);

    return `#${hex.toLowerCase()}`;
  }
}
